import { useState, useEffect } from "react";
import {
  getAllAdminPasswords,
  deleteAdminPassword,
  updateAdminPassword,
  addAdminPassword,
} from "../../../../REDUX/Models/admin.Model";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";

export default function Passes({ goBack }) {
  const [passwords, setPasswords] = useState([]);
  const [password, setPassword] = useState("");
  const [link, setLink] = useState("");
  const [editId, setEditId] = useState(null);

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[^\s]{8,}$/;

  const availableLinks = [
    "/admin/adm",
    "/admin/pub",
    "/admin/cor",
    "/admin/doc",
    "/admin/rev",
  ];

  const resetForm = () => {
    setPassword("");
    setLink("");
    setEditId(null);
  };

  const loadPasswords = () => {
    getAllAdminPasswords()
      .then((data) => setPasswords(data))
      .catch(() => toast.error("فشل في تحميل كلمات المرور"));
  };

  const handleDelete = (id) => {
    const confirmed = window.confirm("هل انت متأكد من حذف كلمة المرور ؟");
    if (confirmed) {
      deleteAdminPassword(id)
        .then(() => {
          loadPasswords();
          toast.success("تم الحذف بنجاح");
        })
        .catch(() => toast.error("فشل في حذف كلمة المرور"));
    }
  };

  const handleEdit = (item) => {
    setPassword("");
    setLink("");
    setEditId(item.id);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!password || !link) {
      toast.error("يجب إدخال كلمة مرور وتحديد الرابط");
      return;
    }

    if (!passwordRegex.test(password)) {
      toast.error(
        "كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل، حرف كبير، حرف صغير، رقم، ورمز خاص."
      );
      return;
    }

    if (editId) {
      updateAdminPassword(editId, { password: password, role: link })
        .then(() => {
          loadPasswords();
          resetForm();
          toast.success("تم التحديث بنجاح");
        })
        .catch(() => toast.error("فشل في التحديث"));
    } else {
      addAdminPassword({ password, role: link })
        .then(() => {
          loadPasswords();
          resetForm();
          toast.success("تمت الإضافة بنجاح");
        })
        .catch(() => toast.error("فشل في الإضافة"));
    }
  };

  useEffect(() => {
    loadPasswords();
  }, []);

  return (
    <div className="admin-passwords">
      <div className="container">
        <header>
          <h2>كلمات المرور</h2>
          <p style={{ cursor: "pointer" }} onClick={goBack}>
            اغلاق <i className="fa-light fa-x"></i>
          </p>
        </header>

        <div className="row">
          <div className="add-password">
            <form onSubmit={handleSubmit}>
              <input
                required
                type="text"
                value={password}
                placeholder="كلمة المرور"
                onChange={(e) => setPassword(e.target.value)}
              />

              <select
                value={link}
                onChange={(e) => setLink(e.target.value)}
                required
              >
                <option value="">اختر الرابط</option>
                {availableLinks.map((l) => (
                  <option key={l} value={l}>
                    {l}
                  </option>
                ))}
              </select>
              {editId && (
                <button
                  type="button"
                  className="btn cancel"
                  onClick={resetForm}
                >
                  إلغاء التعديل
                </button>
              )}
              <button className="btn" type="submit">
                {editId ? "تحديث كلمة المرور" : "إضافة كلمة مرور"}
              </button>
            </form>
          </div>

          <div className="view-passwords">
            {passwords.length > 0 ? (
              passwords.map((item) => (
                <div className="password" key={item.id}>
                  <p>الرقم التعريفي: {item.id}</p>
                  <p>الرابط: {item.role}</p>
                  <p>كلمة المرور: ******</p>

                  <div className="actions">
                    <i
                      className="fa-light fa-trash"
                      onClick={() => handleDelete(item.id)}
                    ></i>
                    <i
                      className="fa-light fa-pen"
                      onClick={() => handleEdit(item)}
                    ></i>
                  </div>
                </div>
              ))
            ) : (
              <p>لا توجد كلمات مرور للعرض</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
